import React from 'react';

import * as S from '@/components/views/Report/KimLhc/Report/Steps/Result/styles';

interface InfoRowProps {
	label: string;
	value: string;
}

export function InfoRow({ label, value }: Readonly<InfoRowProps>) {
	return (
		<S.InfoRow>
			<S.InfoLabel>{label}</S.InfoLabel>
			<S.InfoValue>{value}</S.InfoValue>
		</S.InfoRow>
	);
}
